<template>
    <div>
        <div class="header pb-6 d-flex align-items-center">
            <!-- Mask -->
            <span class="mask bg-white opacity-8"></span>
            <!-- Header container -->
            <b-container fluid class="d-flex align-items-center">
                <b-row>
                    <b-col lg="12"><b-row>
                <b-col class="mt-1 mb-1">
                    <div
                        @click="$router.back()"
                        class="icon icon-shape rounded-circle shadow bg-primary text-white"
                    >
                        <i class="fa fa-arrow-left"></i>
                    </div>
                </b-col>
            </b-row> </b-col>
                </b-row>
            </b-container>
        </div>

        <b-container fluid class="mt--5">
            
            <b-row>
                <b-col sm="12" md="8">
                    <HackathonSubmissionJudgeView
                        :hackathon_id="hackathon_id"
                        :submission_id="submission_id"
                    />
                </b-col>
                <b-col sm="12" md="4">
                    <HackathonJudgingWidget
                        :hackathon_id="hackathon_id"
                        :submission_id="submission_id"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import HackathonSubmissionJudgeView from "@/views/Components/Hackathon/Judging/SubmissionJudgeView.vue";
import HackathonJudgingWidget from "@/views/Components/Hackathon/Judging/JudgingWidget.vue";




export default {
    name: "HackathonJudgingCrudSubmissions",
    components: {
        HackathonSubmissionJudgeView,
        HackathonJudgingWidget,
    },
    data() {
        return {
            hackathon_id: null,
            submission_id: null,
        };
    },
    methods: {
        get_hackathon_id() {
            if (this.$route.params.hackathon_id) {
                this.hackathon_id = this.$route.params.hackathon_id;
            } else {
                this.hackathon_id = null;
                // TODO: We need to reroute this if there is no hackathon. Possibly to the discover hackathons page.
            }
        },
        get_submission_id() {
            if (this.$route.params.submission_id) {
                this.submission_id = this.$route.params.submission_id;
            } else {
                this.submission_id = null;
                // TODO: We need to reroute this if there is no hackathon. Possibly to the discover hackathons page.
            }
        },
    },
    mounted() {
        this.get_hackathon_id();
        this.get_submission_id();
    },
};
</script>

<style></style>
